import {Component, Inject, ViewEncapsulation} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {locale as polish} from "../i18n/pl";

@Component({
    selector: 'confirm-open-slot-modal-component',
    templateUrl: './confirmOpenSlotModal.component.html',
    styleUrls: ['./confirmOpenSlotModal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConfirmOpenSlotModalComponent {

    constructor(
        public dialogRef: MatDialogRef<ConfirmOpenSlotModalComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
    ) {
        // this.resource = _data.resource;
        this.translationLoader.loadTranslations(polish);
    }
}
